import { AppBar, Box, Drawer, IconButton, styled } from "@mui/material";

export const StyledSidebar = styled(Box)(({ theme: { palette } }) => ({
  transition: "width 0.5s",
  backgroundColor: palette.main[900],
  minHeight: "100vh",
  maxHeight: "100vh",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyledDrawer = styled(Drawer)(({ theme: { palette } }) => ({
  "& .MuiPaper-root": {
    backgroundColor: palette.main[900],
  },
}));

export const StyledDrawerHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledIconButton = styled(IconButton)(
  ({ theme: { palette, spacing } }) => ({
    color: palette.common.white,
    background: palette.main[500],
    borderTopLeftRadius: 0,
    borderTopRightRadius: spacing(1),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: spacing(1),
    padding: `${spacing(1)} 0`,

    "&:hover": {
      background: palette.main[600],
    },
  }),
);

export const StyledAppBar = styled(AppBar)(({ theme: { palette } }) => ({
  background: palette.main[900],
}));
